import React, { useEffect, useRef, useState } from "react";
import { FormGroup, Input, Label, FormFeedback, Button, Row } from "reactstrap";
import client from "../../../../client";
import config from "../../../../config";

const OTPScreen2 = (props) => {
  const focusRef = useRef([]);
  const [otp, setOTP] = useState([]);
  const [verified, changeVerify] = useState(false);
  const [otpList, setOtpList] = useState([1, 2, 3, 4, 5, 6]);
  const [resendButton, changeResendButton] = useState(false);
  const [isPaste, setIsPaste] = useState(false);
  const [inputIndex, setInputIndex] = useState(0);
  const [invalidOTP, setInvalidOTP] = useState(false);
  const [timer, setTimer] = useState({
    minutes: 1,
    seconds: 59,
  });

  useEffect(() => {
    if (!verified) {
      generateOTP();
    }
  }, []);

  useEffect(() => {
    if (timer.minutes == 0 && timer.seconds == 0) {
      changeResendButton(true);
    } else {
      setTimeout(() => {
        setTimer({
          ...timer,
          ...(timer.seconds == 0
            ? { minutes: timer.minutes - 1, seconds: 59 }
            : { seconds: timer.seconds - 1 }),
        });
      }, 1000);
    }
  }, [timer]);

  const generateOTP = () => {
    const payload = {
      phoneNumber: props.phoneNumber,
    };
    client()
      .post(`${config.publicAPI}/generateotp`, payload)
      .then((res) => {
        changeVerify(true);
      })
      .catch((error) => {
        console.log("Error", error);
        changeVerify(false);
      });
    changeResendButton(false);
    setTimer({ ...timer, minutes: 1, seconds: 59 });
  };

  const verifyOTP = () => {
    const { phoneNumber, requiredRole, authenticationCallback } = props;
    const payload = {
      isSessionRequired: true,
      otp: otp.join(""),
      phoneNumber,
      requiredRole,
    };
    client()
      .post(`${config.publicAPI}/verifyotp`, payload)
      .then((res) => {
        console.log(res.data);
        if (res.data.code === 200) {
          let user = localStorage.getItem("user");
          user = typeof user === "string" && JSON.parse(user);
          const newUser = {
            token: res.data.latestToken,
            ...res.data.data,
          };

          if (res.data.hasError) {
            setInvalidOTP(true);
          } else {
            if (user.token != res.data.latestToken) {
              // localStorage.setItem('user', JSON.stringify(newUser));
              window.user = newUser;
            }
            authenticationCallback();
          }
        } else {
          let user = localStorage.getItem("user");
          user = typeof user === "string" ? JSON.parse(user) : user;
          window.user = user;
          setInvalidOTP(true);
        }
      })
      .catch((error) => {
        setInvalidOTP(true);
      });
  };

  const otpType = (e, i) => {
    let isBackSpace = e.key === "Backspace" ? i - 1 : i + 1;
    if (focusRef.current[isBackSpace] && isPaste == false) {
      focusRef.current[isBackSpace].focus();
      setInputIndex(isBackSpace);
    }
    const newOtp = [...otp];
    newOtp[i] = e.target.value;
    setOTP(newOtp);
  };

  const pasteOTP = (e) => {
    e.preventDefault();
    setIsPaste(true);
    const pastedText = e.clipboardData.getData("text");
    const newOtp = [...pastedText];
    focusRef.current[0].value = newOtp[0];
    focusRef.current[1].value = newOtp[1];
    focusRef.current[2].value = newOtp[2];
    focusRef.current[3].value = newOtp[3];
    focusRef.current[4].value = newOtp[4];
    focusRef.current[5].value = newOtp[5];
    focusRef.current[5].focus();
    setInputIndex(5);
    setOTP(newOtp);
    setTimeout(() => {
      setIsPaste(false);
    }, 1000);
  };

  return (
    <div className="otp-section">
      <div className="otp-inner-sec">
        <div
          className="input-border"
          style={{ transform: `translateX(${inputIndex * 65}px)` }}
        ></div>
        {otpList.map((ele, i) => {
          return (
            <input
              key={i}
              type="text"
              ref={(el) => (focusRef.current[i] = el)}
              maxLength={1}
              className="otp-input"
              placeholder="0"
              autoFocus={i === 0}
              style={{
                ...(inputIndex == i && {
                  borderColor: "#2da5da",
                }),
              }}
              onKeyUp={(e) => {
                otpType(e, i);
              }}
              onPaste={(e) => {
                pasteOTP(e);
              }}
              onFocus={() => {
                setInputIndex(i);
              }}
            />
          );
        })}
      </div>

      <div
        className={`timer-sec d-flex align-items-center ${
          invalidOTP && !resendButton
            ? "justify-content-between"
            : "justify-content-center"
        }`}
      >
        {invalidOTP ? (
          <div className="invalid-otp-txt">OTP is invalid!</div>
        ) : (
          <div></div>
        )}

        {!resendButton && (
          <span>
            OTP will be expire in{" "}
            <span className={`${timer.minutes ? "green" : "red"}`}>
              {`0${timer.minutes}:${
                timer.seconds < 10 ? `0${timer.seconds}` : timer.seconds
              }`}{" "}
            </span>
            {timer.minutes ? "min" : "sec"}
          </span>
        )}
      </div>

      <div>
        <Button
          size="sm"
          className="verify-otp-btn"
          color="primary"
          onClick={verifyOTP}
          disabled={otp.join("").length !== 6}
        >
          {/* <i className="fa fa-lock pr-2" aria-hidden="true"></i> */}
          Verify OTP
        </Button>
      </div>
      {resendButton && (
        <div className="pb-2 mt-2">
          <span className="resend-otp-link">
            {`Didn't get the code ?`}{" "}
            <Button
              className="pr-2 pl-2 btn btn-link otpResendButton"
              onClick={() => generateOTP()}
              size="sm"
            >
              Click to resend
            </Button>
          </span>
        </div>
      )}
    </div>
  );
};

export default OTPScreen2;
